import React, { useState } from "react";

import "./styles.less";

import { useTranslation } from "react-i18next";
import { Column, Table } from "../NormalTable";

export const SolutionTable = () => {
  const { t } = useTranslation();
  const data = [
    {
      nametype: t("solution.auth0.table.fun"),
      descript: `<a href="https://www.authing.cn/pricing" class='table-href'">${t(
        "solution.auth0.table.fun1"
      )}</a>`,
      dataIndex: "descript",
      okta: `<div style="text-align:center;color:#FB9926;font-weight:bold">$$</div>`,
      authing: `<div style="text-align:center;color:#215AE5;font-weight:bold">$</div>`,
    },
    {
      nametype: (
        <img
          src="//files.authing.co/authing-website/auth0-logo-table.png"
          alt="authing"
          style={{ width: 90 }}
        />
      ),
      descript: `<a href="https://docs.authing.cn/v2/guides/connections/social.html" class='table-href'">${t(
        "solution.auth0.table.fun2"
      )}</a>`,
      dataIndex: "okta",
      okta: "unchecked",
      authing: "checked",
    },
    {
      nametype: (
        <img
          src="//files.authing.co/authing-website/authing-logo-0830.png"
          alt="authing"
          style={{ width: 100 }}
        />
      ),
      descript: `<a href="https://docs.authing.cn/v2/guides/migrations/custom-password-script/" class='table-href'">${t(
        "solution.auth0.table.fun3"
      )}</a>`,
      dataIndex: "authing",
      okta: "unchecked",
      authing: "checked",
    },
    {
      descript: `<a href="https://docs.authing.cn/v2/guides/access-control/abac.html" class='table-href'">${t(
        "solution.auth0.table.fun4"
      )}</a>`,
      dataIndex: "",
      okta: "unchecked",
      authing: "checked",
    },
    {
      descript: t("solution.auth0.table.fun5"),
      dataIndex: "",
      okta: `<div style="text-align:center">${t(
        "solution.auth0.table.auth0Remark"
      )}</div>`,
      authing: `<div style="text-align:center">${t(
        "solution.auth0.table.authingRemark"
      )}</div>`,
    },
    {
      descript: t("solution.auth0.table.fun6"),
      dataIndex: "",
      okta: "checked",
      authing: "checked",
    },
    {
      descript: t("solution.auth0.table.fun7"),
      dataIndex: "",
      okta: "checked",
      authing: "checked",
    },
    {
      descript: `<a href="https://docs.authing.cn/v2/concepts/authentication.html#oidc-oauth2-0-saml-ad-ldap-%E7%A4%BE%E4%BC%9A%E5%8C%96%E7%99%BB%E5%BD%95" class='table-href'">${t(
        "solution.auth0.table.fun8"
      )}</a>`,
      dataIndex: "",
      okta: "checked",
      authing: "checked",
    },
    {
      descript: `<a href="https://docs.authing.cn/v2/multi-tenant-console/#%E5%A4%9A%E7%A7%9F%E6%88%B7%E6%8E%A7%E5%88%B6%E5%8F%B0" class='table-href'">${t(
        "solution.auth0.table.fun9"
      )}</a>`,
      dataIndex: "",
      okta: "checked",
      authing: "checked",
    },
    {
      descript: `<a href="https://docs.authing.cn/v2/guides/authorization/m2m-authz.html" class='table-href'">${t(
        "solution.auth0.table.fun10"
      )}</a>`,
      dataIndex: "",
      okta: "checked",
      authing: "checked",
    },
    {
      descript: `<a href="https://www.authing.co/learn/sso" class='table-href'">${t(
        "solution.auth0.table.fun11"
      )}</a>`,
      dataIndex: "",
      okta: "checked",
      authing: "checked",
    },
    {
      descript: `<a href="https://www.authing.co/mfa" class='table-href'">${t(
        "solution.auth0.table.fun12"
      )}</a>`,
      dataIndex: "",
      okta: "checked",
      authing: "checked",
    },
  ];
  const renderChecked = (value) => {
    const iconStyl = {
      color: "#215AE5",
      textAlign: "center",
      margin: "0 auto",
      display: "block",
      // color: "rgba(57, 106, 255, 0.8)",
    };
    const uniconStyl = {
      color: "#FB9926",
      textAlign: "center",
      margin: "0 auto",
      display: "block",
      fontSize: "19px",
    };
    const checkedIcon = (
      <div>
        <i className="icon authing-icon authing-wancheng" style={iconStyl}></i>
      </div>
    );
    const uncheckedIcon = (
      <div>
        <i
          className="icon authing-icon authing-close-circle-fill1"
          style={uniconStyl}
        ></i>
      </div>
    );
    if (value === "checked") {
      return checkedIcon;
    } else if (value === "unchecked") {
      return uncheckedIcon;
    } else {
      return <div dangerouslySetInnerHTML={{ __html: value }}></div>;
    }
  };
  return (
    <>
      <div className="solution-table">
        <div className="inner">
          <div>
            <div className="solution-table-title">
              {t("solution.auth0.table.title")}
            </div>
            <div className="solution-table-subtitle">
              {t("solution.auth0.table.description1")}
              <br />
              {t("solution.auth0.table.description2")}

              <a
                href="https://www.authing.cn/authingform?fromTag=Auth0功能对比"
                target="_blank"
                rel="noopener noreferrer"
              >
                {t("solution.auth0.table.learnMore")}
                <i className="icon website-icon website-arrow-right-s-fill1"></i>
              </a>
            </div>
          </div>
          <div className="solution-table-frame">
            <Table data={data}>
              {data.map((column) => {
                if (column.nametype) {
                  return (
                    <Column
                      title={column.nametype}
                      dataIndex={column.dataIndex}
                      render={renderChecked}
                      extra={column.extra}
                      descript={column.descript}
                    />
                  );
                } else {
                  return <></>;
                }
              })}
            </Table>
          </div>
        </div>
      </div>
    </>
  );
};
